import { request } from '@luna/api';
import { getEnv } from '@luna/env';
import { createQueryString } from '@luna/router';
import { deepClean } from '@luna/utils';
import { logger } from '@luna/logger';

import type { ExportsSetsMetadataResponse } from '../types';

const DEFAULT_PAGE_SIZE = 20;

type SearchArgs = {
    name?: string;
    pageSize?: number;
    page?: number;
    sort?: string;
};

export async function fetchMetadataExportsSets({
    name,
    pageSize = DEFAULT_PAGE_SIZE,
    page = 0,
}: SearchArgs): Promise<ExportsSetsMetadataResponse> {
    const urlParams: SearchArgs = {
        page,
        pageSize,
        name,
    };

    const queryString = createQueryString(deepClean(urlParams));
    const url = `${getEnv().apiGatewayUrl}export-center/public/export-sets${queryString}`;

    return request<ExportsSetsMetadataResponse>(url).catch((error) => {
        logger.error('Exports Sets :: Metadata loading failed', error);
        throw error;
    });
}
